import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { List } from './List';
import { AddEdit } from './AddEdit';
import { ViewContact } from './ViewContact';
import ProtectedRoute from '../PrivateRoute';

function Contacts( {match} ) {
    const { path } = match;

    return (
        <Switch>
            <ProtectedRoute exact path={path} component={List} />
            <Route path={`${path}/add`} component={AddEdit} />
            <Route path={`${path}/edit/:id`} component={AddEdit} />
            <Route path={`${path}/view/:id`} component={ViewContact} />
        </Switch>
    );
}

export { Contacts };